import { TabsDesignTokens } from '@primeuix/themes/types/tabs';

export const tabs: TabsDesignTokens = {
  tabpanel: {
    background: 'transparent',
    padding: '20px 0',
  },
  tablist: {
    background: 'transparent',
  },
};
